import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { SupporterVoicesFeedContextValueType } from './types';

/** @knip-ignore */
export const {
	Context: SupporterVoicesFeedContext,
	Provider: SupporterVoicesFeedContextBaseProvider,
	useContext: useSupporterVoicesFeedContext,
} = createMandatoryContext<SupporterVoicesFeedContextValueType>(undefined, {
	name: 'SupporterVoicesFeedContext',
});
